var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '매칭상담회'
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('fair-view', {
    on: {
      "apply": _vm.apply
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var fair = _ref.fair;
        return [_c('div', {
          staticClass: "tab-menu"
        }, [_c('div', {
          staticClass: "swiper-container"
        }, [_c('div', {
          staticClass: "swiper-wrapper"
        }, _vm._l(_vm.list, function (item) {
          return _c('tab-item', _vm._b({
            key: item.id,
            model: {
              value: _vm.currentId,
              callback: function callback($$v) {
                _vm.currentId = $$v;
              },
              expression: "currentId"
            }
          }, 'tab-item', item, false));
        }), 1)])]), fair ? _c('div', {
          staticClass: "tab-contents"
        }, [_c('transition', [_c('section', {
          key: _vm.currentId,
          staticClass: "item"
        }, [_vm.currentId == 1 ? _c('fair-view-intro', {
          attrs: {
            "fair": fair
          }
        }) : _vm._e(), _vm.currentId == 2 && !_vm.product ? _c('product-list', {
          attrs: {
            "fair": fair,
            "show-category": "",
            "show-award": "",
            "show-keyword": "",
            "show-pagination": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var products = _ref2.products;
              return _vm._l(products, function (product) {
                return _c('product-list-item', {
                  key: product._id,
                  attrs: {
                    "product": product,
                    "disabled": !_vm.scope.includes('buyer')
                  },
                  on: {
                    "click": function click(product) {
                      return _vm.$data.product = product;
                    }
                  }
                });
              });
            }
          }], null, true)
        }) : _vm._e(), _vm.currentId == 2 && _vm.product ? _c('fair-product-view', {
          attrs: {
            "fair": fair,
            "product": _vm.product,
            "show-back": ""
          },
          on: {
            "back": function back($event) {
              _vm.product = null;
            }
          }
        }) : _vm._e(), _vm.currentId == 3 ? _c('application-seller', {
          attrs: {
            "_fair": fair._id
          }
        }) : _vm._e(), _vm.currentId == 4 ? _c('application-buyer', {
          attrs: {
            "_fair": fair._id
          }
        }) : _vm._e()], 1)])], 1) : _vm._e()];
      }
    }])
  }), _c('fair-modal', {
    ref: "fair-modal"
  })], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }